import { createContext } from 'react';

const MetaContext = createContext({
    onDeleteSensor: () => {},
    onSelectSensor: () => {}
});

export default MetaContext;
